import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import {
  underlineFocus,
  FocusSpan,
} from 'portal-modules/common/components/focus-styles'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'


const StyledLi = styled('li')`
  .tabs--header & {
    flex: 0 0 auto;
    padding: 0 4px;
  }

  .tabs--content & {
    display: inline-block;

    :not(:last-child) a {
      border-right: none;
    }
  }
`

const StyledButton = styled('button')`
  font-size: 13px;
  display: block;
  text-decoration: none;

  .tabs--header & {
    padding: 0 8px 12px;
    color: ${({ theme }) =>
      getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.gray4};
    background: none;
    border: none;

    &.active {
      position: relative;

      ::after {
        content: '';
        width: 100%;
        height: 4px;
        background: white;
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }

  .tabs--content & {
    background: ${({ theme }) => theme.gray.highlight};
    border: 1px solid ${({ theme }) => theme.gray.light};
    color: ${({ theme }) => theme.gray.base};
    padding: 4px 16px;

    &.active {
      background: white;
      color: ${({ theme }) => theme.secondary.base};
    }
  }

  &.active {
    font-weight: bold;
  }

  ${underlineFocus}
`

const TabNavNoLinkItem = ({ children, ...rest }) => (
  <StyledLi>
    <StyledButton {...rest}>
      <FocusSpan>{children}</FocusSpan>
    </StyledButton>
  </StyledLi>
)

TabNavNoLinkItem.propTypes = {
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default TabNavNoLinkItem
